<template>
  <div class="error">
    Abnormal data acquisition, please rescan the QR code
  </div>
</template>
<script>


export default {
  name: 'Error',
  data() {
    return {
    };
  },
  methods: {
  },
  created() {
  },
};
</script>
<style lang="less" scoped>
.error {
  font-family: 'PawSwingPixelFont';
  background: #000;
  min-height: 100vh;
  color: #fff;
  padding: 48px;
}
</style>
